import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from './../../utils/api';
import { numberFormat } from './../../utils/functions';
import './BalancePayCard.css';

/**
 * กล่อง "ยอดคงเหลือ + ปุ่มชำระเงินออนไลน์" บนหน้าสถานะการจอง
 *
 * หน้านี้คือปลายทางของทั้งลิงก์ใน SMS ก่อนเช็คอิน และ QR ที่พนักงานให้ลูกค้าสแกนที่หน้างาน
 * เซิร์ฟเวอร์เป็นคนตัดสินว่าจ่ายออนไลน์ได้ไหม (ที่พักใช้ gateway, เปิดให้จ่ายยอดคงเหลือออนไลน์,
 * จ่ายรอบแรกแล้ว, ยังมียอดค้าง) -- ไม่ได้ก็ไม่แสดงอะไรเลย หน้าสถานะเลยเหมือนเดิมทุกอย่าง
 * สำหรับที่พักโอนตรงและการจองที่จ่ายครบแล้ว
 *
 * props: type = 'booking' | 'main' | 'cart', id, code (เลขจอง / เลขตะกร้า)
 */
export default function BalancePayCard({ type, id, code }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!id || !code) return;
    const idField = type === 'cart' ? 'booking_cart_id' : (type === 'main' ? 'booking_main_id' : 'booking_id');
    api.request('omise-payments/balance', (res, success) => {
      setInfo(success ? res : null);
    }, { [idField]: id, code }, 'GET', { showError: false });
  }, [type, id, code]);

  // จองตอนที่พักยังรับโอนตรง สลิปมัดจำยังไม่ได้ตรวจ -- บอกว่าทำไมยังไม่มีปุ่มจ่าย
  if (info && info.reason === 'deposit_slip_pending') {
    return (
      <div className="balance-pay balance-pay--pending">
        <div className="balance-pay__info">
          <div className="balance-pay__label">{t('balance_card_title')}</div>
          <div className="balance-pay__amount">฿{numberFormat(info.amount, true)}</div>
          <div className="balance-pay__note">{t('balance_slip_pending')}</div>
        </div>
      </div>
    );
  }

  if (!info || !info.payable) return null;

  const pay = () => navigate(`/once/payment/${type}/${id}?purpose=balance&code=${encodeURIComponent(code)}`);

  return (
    <div className="balance-pay">
      <div className="balance-pay__info">
        <div className="balance-pay__label">{t('balance_card_title')}</div>
        <div className="balance-pay__amount">฿{numberFormat(info.amount, true)}</div>
        <div className="balance-pay__note">
          {info.mode === 'online' ? t('balance_must_pay_online') : t('balance_or_pay_on_stay')}
        </div>
      </div>
      <button type="button" className="balance-pay__btn" onClick={pay}>
        {t('balance_pay_online')}
        <span className="balance-pay__btn-hint">{t('balance_pay_online_hint')}</span>
      </button>
    </div>
  );
}
